export default __webpack_public_path__ + "static/media/tedxdetroit.d07459ba.webp";